/**
 * Durée annoncée par une unité de travail ou un item de file.
 *
 * C'est une DONNÉE, donc mono et neutre — pas un `.badge`, qui ajouterait une
 * pastille de couleur à une information qui n'a pas de statut. « La durée
 * annoncée par item est ce qui rend la file crédible : on sait avant de
 * commencer si on a le temps de la vider. »
 */
export function ChipTemps({ children, aDroite }: { children: string; aDroite?: boolean }) {
  return <span className={aDroite ? 'chip-time wq-spacer' : 'chip-time'}>{children}</span>;
}
